// extracted by mini-css-extract-plugin
export default {"Navigation":"Navigation_Navigation__WYjpb","Active":"Navigation_Active__kKaau","open":"Navigation_open__Xu6cX","close":"Navigation_close__cgrL2"};